import { Cell } from '../structures/2d/cell.js';
import { Grid } from '../structures/2d/grid.js';

export class GridManager {
	constructor( modules, managers ) {
		this.modules = modules;
		this.managers = managers;
		this.managers.GridManager = this;
		this.grid = new Grid();
	}

	async init( conf ) {
		/*
			we should get a config similiar to this:
			{
				capillas: "12",				// number of capillas, equal to number of columns
				largo: "80",
				malla:"3",					// length of each capilla, fixed values from DB
				opcion:"",					// defalt options, fixed values from DB
				estructura:"ASYSTARTER",
				ancho:"6.4"					// width of each capilla, fixed values from DB
			}
		*/
	
		// parse config to numeric values
		const numConf = this.#parseToNumericValues( conf );

		//in case we have an extra row of a different size. For example: 80/3 = 26, so 3m * 26 rows and an extra row of 2m
		const numRows = parseInt( numConf.length / numConf.meshes );
		const extraRow = numConf.length % numConf.meshes;
		const numColumns = numConf.chappels;

		this.clearGrid();

		for( let i = 0; i < numColumns; i++ ) {

			let cell = null;
			let position = null;

			for( let j = 0; j < numRows; j++ ) {
				cell = new Cell();
				cell.init( j, i, numConf.meshes, numConf.widths, numConf.estructura, this.grid );
				position = { row: j, column: i };
				
				this.grid.addCell( position, cell );
			}
			if( extraRow > 0 ) {
				cell = new Cell();
				cell.init( numRows, i, extraRow, numConf.widths, numConf.estructura, this.grid );
				position = { row: numRows, column: i };
				
				this.grid.addCell( position, cell );
			}
		}

		//set grid general conf
		this.grid.numRows = numRows + ( extraRow > 0 ? 1 : 0 );
		this.grid.numColumns = numColumns;
		this.grid.options = numConf.options;
		this.grid.estructura = numConf.estructura;

		return this.grid;
	}

	resizeRow( row, newLength ) {
		const cells = this.grid.getCellsInRow( row );
		for( let i = 0; i < cells.length; i++ ) cells[i].length = newLength;
	}

	resizeColumn( column, newWidth ) {
		const cells = this.grid.getCellsInColumn( column );
		for( let i = 0; i < cells.length; i++ ) cells[i].width = newWidth;
	}

	#parseToNumericValues( conf ) {
		
		let chappels = 0;
		let length = 0;
		let meshes = 0;
		let widths = 0;
		
		try{ chappels = parseFloat( conf.capillas ); } catch( e ) { console.error( 'error parsing number of chappels' ); }
		try{ length = parseFloat( conf.largo ); } catch( e ) { console.error( 'error parsing length' ); }
		try{ meshes = parseFloat( conf.malla ); } catch( e ) { console.error( 'error parsing meshes' ); }
		try{ widths = parseFloat( conf.ancho ); } catch( e ) { console.error( 'error parsing widths' ); }

		return {
			chappels: chappels,
			length: length,
			meshes: meshes,
			widths: widths,
			estructura: conf.estructura,
			options: conf.options
		};
	}

	deleteCells( cells ) {
		cells.forEach( cell => {
			cell.visible = false;
		} );
	}

	clearGrid() {
		this.grid.clear();
	}

}